/**
 * Main Content Component
 * 
 * This component renders the appropriate page content
 * based on the active tab selection.
 */

import React from 'react';
import { useApp } from '../../context/AppContext';
import DashboardPage from '../../pages/DashboardPage';
import OrdersPage from '../../pages/OrdersPage';
import RetrievalPage from '../../pages/RetrievalPage';
import CustomersPage from '../../pages/CustomersPage';
import WhatsAppPage from '../../pages/WhatsAppPage';
import CalculatorPage from '../../pages/CalculatorPage';
import ServicePage from '../../pages/ServicePage';
import SettingsPage from '../../pages/SettingsPage';

const MainContent = () => {
  const { state } = useApp();

  const renderContent = () => {
    switch (state.activeTab) {
      case 'dashboard':
        return <DashboardPage />;
      case 'orders':
        return <OrdersPage />;
      case 'retrieval':
        return <RetrievalPage />;
      case 'customers':
        return <CustomersPage />;
      case 'whatsapp':
        return <WhatsAppPage />;
      case 'calculator':
        return <CalculatorPage />;
      case 'services':
        return <ServicePage />;
      case 'settings':
        return <SettingsPage />;
      default:
        return <DashboardPage />;
    }
  };

  return (
    <main className="app-main">
      {renderContent()}
    </main>
  );
};

export default MainContent;
